import { CartAddEvent } from '@theme/events';
import { fetchConfig } from '@theme/utilities';

const CARD_GAP = 8;
let drag = null;
let suppressClick = false;

function getStrip(target) {
  return target instanceof Element ? target.closest('[data-cart-upsells]') : null;
}

function getStep(strip) {
  const card = strip.querySelector('.cart-upsell');
  return card ? card.getBoundingClientRect().width + CARD_GAP : strip.clientWidth;
}

function updateDots(strip) {
  const dots = strip.parentElement ? strip.parentElement.querySelectorAll('[data-cart-upsell-dot]') : [];
  if (!dots.length) return;
  const index = Math.min(Math.round(strip.scrollLeft / getStep(strip)), dots.length - 1);
  dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
  strip.parentElement.querySelectorAll('[data-cart-upsell-arrow]').forEach((arrow) => {
    arrow.disabled = index + Number(arrow.getAttribute('data-cart-upsell-arrow')) < 0 || index + Number(arrow.getAttribute('data-cart-upsell-arrow')) > dots.length - 1;
  });
}

function endDrag() {
  if (!drag) return;
  const { strip, moved } = drag;
  drag = null;
  if (!moved) return;
  strip.classList.remove('is-dragging');
  suppressClick = true;
  setTimeout(() => {
    suppressClick = false;
  }, 0);
  const step = getStep(strip);
  strip.scrollTo({ left: Math.round(strip.scrollLeft / step) * step, behavior: 'smooth' });
}

document.addEventListener('pointerdown', (event) => {
  if (event.pointerType !== 'mouse' || event.button !== 0) return;
  const strip = getStrip(event.target);
  if (!strip) return;
  drag = { strip, startX: event.clientX, startLeft: strip.scrollLeft, moved: false };
});

document.addEventListener('pointermove', (event) => {
  if (!drag) return;
  if (event.buttons === 0) {
    endDrag();
    return;
  }
  const dx = event.clientX - drag.startX;
  if (!drag.moved) {
    if (Math.abs(dx) < 5) return;
    drag.moved = true;
    drag.strip.classList.add('is-dragging');
  }
  drag.strip.scrollLeft = drag.startLeft - dx;
});

document.addEventListener('pointerup', endDrag);
document.addEventListener('pointercancel', endDrag);

document.addEventListener(
  'click',
  (event) => {
    if (!suppressClick) return;
    event.stopPropagation();
    event.preventDefault();
  },
  true
);

document.addEventListener('click', (event) => {
  const dot = event.target instanceof Element ? event.target.closest('[data-cart-upsell-dot]') : null;
  if (!dot) return;
  const wrap = dot.closest('.cart-upsells-wrap');
  const strip = wrap ? wrap.querySelector('[data-cart-upsells]') : null;
  if (!strip) return;
  strip.scrollTo({ left: Number(dot.getAttribute('data-cart-upsell-dot')) * getStep(strip), behavior: 'smooth' });
});

document.addEventListener('click', (event) => {
  const arrow = event.target instanceof Element ? event.target.closest('[data-cart-upsell-arrow]') : null;
  if (!arrow || arrow.disabled) return;
  const wrap = arrow.closest('.cart-upsells-wrap');
  const strip = wrap ? wrap.querySelector('[data-cart-upsells]') : null;
  if (!strip) return;
  strip.classList.remove('is-dragging');
  const step = getStep(strip);
  const index = Math.round(strip.scrollLeft / step) + Number(arrow.getAttribute('data-cart-upsell-arrow'));
  strip.scrollTo({ left: Math.max(0, index) * step, behavior: 'smooth' });
});

document.addEventListener(
  'scroll',
  (event) => {
    const strip = getStrip(event.target);
    if (strip) updateDots(strip);
  },
  true
);

document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-cart-upsell-add]') : null;
  if (!button || button.disabled) return;

  const variantId = button.getAttribute('data-variant-id');
  if (!variantId) return;

  const label = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding...';

  let upsellTags = [];
  try {
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    const raw = cart.attributes && cart.attributes.upsell_items;
    upsellTags = raw ? raw.split(' | ').filter(Boolean) : [];
  } catch (error) {
    console.error(error);
  }
  const upsellName = button.getAttribute('data-upsell-name') || variantId;
  if (!upsellTags.includes(upsellName)) upsellTags.push(upsellName);

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('attributes[upsell_items]', upsellTags.join(' | '));
  formData.append('quantity', '1');

  const sectionIds = [];
  document.querySelectorAll('cart-items-component').forEach((item) => {
    if (item instanceof HTMLElement && item.dataset.sectionId) sectionIds.push(item.dataset.sectionId);
  });
  formData.append('sections', sectionIds.join(','));

  try {
    const fetchCfg = fetchConfig('javascript', { body: formData });
    const response = await fetch(Theme.routes.cart_add_url, {
      ...fetchCfg,
      headers: { ...fetchCfg.headers, Accept: 'text/html' },
    });
    const data = await response.json();

    if (data.status) {
      button.disabled = false;
      button.textContent = label;
      return;
    }

    button.dispatchEvent(
      new CartAddEvent({}, variantId, {
        source: 'cart-upsell',
        itemCount: 1,
        sections: data.sections,
      })
    );
  } catch (error) {
    console.error(error);
    button.disabled = false;
    button.textContent = label;
  }
});
